import React from "react";
import { Link, Outlet } from "react-router-dom";
import {
  FaChartLine,
  FaUserEdit,
  FaRegEnvelope,
  FaUsers,
  FaListUl,
  FaRegCalendarCheck,
  FaRegComments,
  FaReadme
} from "react-icons/fa";
import { RiFileAddLine } from "react-icons/ri";
import "./Dashboard.css";

const Dashboard = ({ showMenu, toggleMenu }) => {
  const decor = {
    textDecoration: "none",
  };

  //   if (!showMenu) return;

  return (
    <div className="dashboard-container">
      <div className={showMenu ? "dashboard-naver" : "dashboard-nav"}>
        <div className="nav-new">
          <div className="dashboard-links">
            <div className="main">
              <div className="dash-nav-flex">
                <h3 className="dash-link-head">Main</h3>
              </div>
            </div>
          </div>
          <div onClick={() => toggleMenu()}>
            <Link
              style={decor}
              className="dash-link-flex"
              to="/dashboard/dashboard-home"
            >
              <FaChartLine className="dash-link-icon" />{" "}
              <li className="home">Dashboard</li>
            </Link>
            <Link
              style={decor}
              className="dash-link-flex"
              to="/dashboard/transaction"
            >
              <FaChartLine className="dash-link-icon" />{" "}
              <li className="home">Transactions</li>
            </Link>
            <Link
              style={decor}
              className="dash-link-flex"
              to="/dashboard/individual_application"
            >
              <FaReadme className="dash-link-icon" />{" "}
              <li className="home">Individual Application</li>
            </Link>
            <Link
              style={decor}
              className="dash-link-flex"
              to="/dashboard/coperate_application"
            >
              <FaReadme className="dash-link-icon" />{" "}
              <li className="home">Coperate Application</li>
            </Link>
            <Link style={decor} className="dash-link-flex" to="/dashboard/edit">
              <FaUserEdit className="dash-link-icon" />{" "}
              <li className="home">Edit profile</li>
            </Link>
            <Link
              style={decor}
              className="dash-link-flex"
              to="/dashboard/message"
            >
              <FaRegEnvelope className="dash-link-icon" />{" "}
              <li className="home">Messages</li>
            </Link>
            <Link
              style={decor}
              className="dash-link-flex"
              to="/dashboard/agent-list"
            >
              <FaUsers className="dash-link-icon" />{" "}
              <li className="home">Agents List</li>
            </Link>
            <h3 className="dash-link-header">Listings</h3>
            <Link
              style={decor}
              className="dash-link-flex"
              to="/dashboard/my-listings"
            >
              <FaListUl className="dash-link-icon" />{" "}
              <li className="home">My Listings</li>
            </Link>
            <Link
              style={decor}
              className="dash-link-flex"
              to="/dashboard/bookings"
            >
              <FaRegCalendarCheck className="dash-link-icon" />
              <li className="home">Bookings</li>
            </Link>
            <Link
              style={decor}
              className="dash-link-flex"
              to="/dashboard/reviews"
            >
              <FaRegComments className="dash-link-icon" />{" "}
              <li className="home">Reviews</li>
            </Link>
            <Link
              style={decor}
              className="dash-link-flex"
              to="/dashboard/add-new"
            >
              <RiFileAddLine className="dash-link-icon" />{" "}
              <li className="home">Add New</li>
            </Link>
          </div>
        </div>
        <p className="dash-footer">© Homeradar 2022.</p>
      </div>
      <div className="dashboard-content">
        <Outlet />
      </div>
    </div>
  );
};

export default Dashboard;
